import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  title: Yup.string().min(1).required("Title is required"),
  content: Yup.string().min(1).required("Script is required"),
});
